import Vue from 'vue'
import Router from 'vue-router'

import routes from './routes'
import router from './router'

Vue.use(Router)

const { BASE_URL } = process.env

export default new Router({
  mode: 'history',
  base: BASE_URL,
  routes: [
    {
      component: routes.MAIN_CONTENT.component,
      meta: { title: 'Ad Manager' },
      name: 'admanager',
      path: '/admanager/:baseReportName?/:associationId?/:subId?/:reportPath?',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: { title: 'Dashboard' },
      name: 'dashboard',
      path: '/dashboard/:associationId?/:subId?/:reportPath?',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: { title: 'Delivery' },
      name: 'delivery',
      path: '/delivery/:baseReportName?/:associationId?/:subId?/:reportPath?',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: { title: 'Develop' },
      name: 'develop',
      path: '/develop/:baseReportName?',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: { title: 'Docs' },
      name: 'docs',
      path: '/docs/:baseReportName?',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: { title: 'Internal' },
      name: 'internal',
      path: '/internal/:baseReportName?/:associationId?/:subId?/:reportPath?',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: { title: 'Programmatic' },
      name: 'programmatic',
      path: '/programmatic/:baseReportName?/:associationId?/:subId?/:reportPath?',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: { title: 'Custom Analytics' },
      name: 'custom-analytics',
      path: '/custom-analytics/:baseReportName?/:associationId?',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: { title: 'Dev' },
      name: 'dev',
      path: '/dev/:baseReportName?',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: { title: 'Sign In' },
      name: 'sign-in',
      path: '/sign-in',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: { title: 'Sign Out' },
      name: 'sign-out',
      path: '/sign-out',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: { title: 'Index' },
      name: 'index',
      path: '/index.html',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: { title: 'Home' },
      name: 'home',
      path: '/',
      props: router.props,
    },
  ],
})
